import {useState} from "react";
import classNames from "classnames";
import {ImageIcon} from "../atoms/icon";
import {FormattedText} from "../formatted-text";

/**
 * Displays an accordion.
 *
 * @param term
 *   The term to group by.
 * @param products
 *   The products.
 * @param gridKey
 *   A key parameter, to prevent filters from filtering other containers.
 * @param defaultOpen
 *   Whether to set the accordion open by default.
 * @constructor
 */
export function WidgetAccordion({
  title,
  content
}: {
  title: string,
  content: string,
}) {
  const [active, setActive] = useState(false);

  /**
   * Create a simple triangle.
   *
   * @todo this is also used in key_value_page--support.tsx, let's refactor.
   *
   * @constructor
   */
  function Triangle({active}: {active: boolean}): JSX.Element {
    return <span className={classNames(
      "flex pr-4 transition-all duration-500 ease-in-out",
      {"transform rotate-90 -translate-x-5 translate-y-2.5": active},
    )}>
      <ImageIcon type="chevron-right" color="black" height={25} width={25} alt={"Expand or Collapse"} className="items-center max-h-[23px] mt-[5px]"/>
    </span>
  }

  return (
    // @todo this is re-used code from the key_value_page--support.tsx FAQ section - refactor.
    <div>
      <div className="flex bg-white drop-shadow-sm cursor-pointer py-5" onClick={() => setActive(!active)}>
        <h3 className="px-8 text-left !font-light flex-grow">{title}</h3>
        <Triangle active={active}/>
      </div>
      <div className={classNames(
        "overflow-hidden transition-all delay-200 ease-linear origin-top py-4 border-l-4 border-primary",
        {"hidden": !active},
      )}>
        <div className="container px-6 mx-auto text-left">
          <FormattedText processed={content}/>
        </div>
      </div>
    </div>
  )
}